(function(){
  const root = document.getElementById('htb02-nativefinal');
  if (!root) return;

  (function(){
    function fmt(d){var months=['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];return 'Updated '+months[d.getMonth()]+' '+d.getDate()+', '+d.getFullYear();}
    var dateNode=root.querySelector('#htb02nf-io9yv');
    if(dateNode){
      var updated=dateNode.querySelector('.golf-updated');
      if(updated) updated.textContent=fmt(new Date());
    }
  })();

  const videos=Array.from(root.querySelectorAll('video[data-golf-autoplay="1"]'));
  const visible=(video)=>{const r=video.getBoundingClientRect();return r.bottom>0&&r.top<window.innerHeight&&r.width>0&&r.height>0;};
  const requestPlay=(video)=>{
    video.muted=true;video.defaultMuted=true;video.autoplay=true;video.loop=true;video.playsInline=true;video.preload='auto';
    video.setAttribute('muted','');video.setAttribute('autoplay','');video.setAttribute('loop','');video.setAttribute('playsinline','');video.setAttribute('webkit-playsinline','');video.setAttribute('preload','auto');
    video.dataset.autoplayState='requested';
    const promise=video.play();
    if(promise&&typeof promise.then==='function'){
      promise.then(()=>{video.dataset.autoplayState='playing';}).catch(()=>{video.dataset.autoplayState='blocked';});
    }
  };
  videos.forEach((video)=>{
    video.muted=true;video.defaultMuted=true;video.playsInline=true;video.preload='auto';video.load();
    ['loadedmetadata','loadeddata','canplay'].forEach((eventName)=>video.addEventListener(eventName,()=>{if(visible(video))requestPlay(video);},{passive:true}));
  });
  if('IntersectionObserver' in window){
    const observer=new IntersectionObserver((entries)=>entries.forEach((entry)=>{
      if(entry.isIntersecting)requestPlay(entry.target);else entry.target.pause();
    }),{threshold:.08,rootMargin:'160px 0px'});
    videos.forEach((video)=>observer.observe(video));
  }else{videos.forEach((video)=>{if(visible(video))requestPlay(video);});}
  const retryVisible=()=>videos.forEach((video)=>{if(visible(video))requestPlay(video);});
  [80,600,1800].forEach((delay)=>window.setTimeout(retryVisible,delay));
  document.addEventListener('touchstart',retryVisible,{once:true,passive:true});
  document.addEventListener('pointerdown',retryVisible,{once:true,passive:true});
  document.addEventListener('visibilitychange',()=>{if(!document.hidden)retryVisible();});

  const sticky = root.querySelector('.htb02nf-sticky');
  if (!sticky) return;
  const triggerText = 'INTRODUCING THE DAYWICK 4-IN-1 HIP THERAPY BELT';
  const trigger = Array.from(root.querySelectorAll('h1,h2,h3,h4,h5,h6,div,span,p')).filter(function(el){return (el.textContent||'').replace(/\s+/g,' ').trim().includes(triggerText);}).sort(function(a,b){return (a.textContent||'').trim().length-(b.textContent||'').trim().length;})[0]||null;
  sticky.classList.remove('htb02nf-sticky-visible');
  let ticking=false;
  const revealPoint=()=>{if(!trigger)return Math.min(700,document.documentElement.scrollHeight*.25);const top=trigger.getBoundingClientRect().top+(window.scrollY||window.pageYOffset||0);return Math.max(0,top-window.innerHeight*.70);};
  const update=()=>{ticking=false;const y=window.scrollY||window.pageYOffset||0;const point=revealPoint();if(y>=point)sticky.classList.add('htb02nf-sticky-visible');else if(y<point-400)sticky.classList.remove('htb02nf-sticky-visible');};
  const requestUpdate=()=>{if(ticking)return;ticking=true;window.requestAnimationFrame(update);};
  window.addEventListener('scroll',requestUpdate,{passive:true});window.addEventListener('resize',requestUpdate,{passive:true});update();
})();
